module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-100.woff2?46a15b4fc54cfca883f84d6dd080cd3d";